import * as i0 from '@angular/core';
import { Directive, HostBinding, EventEmitter, Component, ViewEncapsulation, ChangeDetectionStrategy, Input, Output, NgModule } from '@angular/core';
import * as i2 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i1 from '@niceltd/sol/translation';
import { TranslationModule } from '@niceltd/sol/translation';
function InlineNotification_div_0__svg_svg_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(0, "svg", 9)(1, "title");
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(4, "path", 10);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 1, "successNotification"));
  }
}
function InlineNotification_div_0__svg_svg_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(0, "svg", 9)(1, "title");
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(4, "path", 11);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 1, "infoNotification"));
  }
}
function InlineNotification_div_0__svg_svg_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(0, "svg", 12)(1, "title");
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(4, "path", 13);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 1, "warningNotification"));
  }
}
function InlineNotification_div_0__svg_svg_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(0, "svg", 9)(1, "title");
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(4, "path", 14);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 1, "errorNotification"));
  }
}
function InlineNotification_div_0_Conditional_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 6);
  }
  if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("innerHTML", ctx_r5.title, i0.ɵɵsanitizeHtml);
  }
}
function InlineNotification_div_0_Conditional_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 7);
  }
  if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("innerHTML", ctx_r6.message, i0.ɵɵsanitizeHtml);
  }
}
function InlineNotification_div_0_button_9_Template(rf, ctx) {
  if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 15);
    i0.ɵɵlistener("click", function InlineNotification_div_0_button_9_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r9);
      const ctx_r8 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r8.onClose());
    });
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(1, "svg", 16);
    i0.ɵɵelement(2, "path", 17);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r7 = i0.ɵɵnextContext(2);
    i0.ɵɵattribute("aria-label", ctx_r7.closeLabel);
  }
}
function InlineNotification_div_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 1)(1, "div", 2);
    i0.ɵɵtemplate(2, InlineNotification_div_0__svg_svg_2_Template, 5, 3, "svg", 3)(3, InlineNotification_div_0__svg_svg_3_Template, 5, 3, "svg", 3)(4, InlineNotification_div_0__svg_svg_4_Template, 5, 3, "svg", 4)(5, InlineNotification_div_0__svg_svg_5_Template, 5, 3, "svg", 3);
    i0.ɵɵelementStart(6, "div", 5);
    i0.ɵɵtemplate(7, InlineNotification_div_0_Conditional_7_Template, 1, 1, "div", 6)(8, InlineNotification_div_0_Conditional_8_Template, 1, 1, "div", 7);
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(9, InlineNotification_div_0_button_9_Template, 3, 1, "button", 8);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵclassProp("sol-inline-notification-success", ctx_r0.isSuccess)("sol-inline-notification-info", ctx_r0.isInfo)("sol-inline-notification-warning", ctx_r0.isWarning)("sol-inline-notification-error", ctx_r0.isError);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r0.type == "success");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.type == "info");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.type == "warning");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.type == "error");
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(7, ctx_r0.title ? 7 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(8, ctx_r0.message ? 8 : -1);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r0.isCloseHidden);
  }
}
class InlineNotificationTitle {
  constructor() {
    this.baseClass = true;
  }
  static {
    this.ɵfac = function InlineNotificationTitle_Factory(t) {
      return new (t || InlineNotificationTitle)();
    };
  }
  static {
    this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: InlineNotificationTitle,
      selectors: [["", "solInlineNotificationTitle", ""]],
      hostVars: 2,
      hostBindings: function InlineNotificationTitle_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵclassProp("sol-inline-notification-title", ctx.baseClass);
        }
      }
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(InlineNotificationTitle, [{
    type: Directive,
    args: [{
      selector: '[solInlineNotificationTitle]'
    }]
  }], null, {
    baseClass: [{
      type: HostBinding,
      args: ['class.sol-inline-notification-title']
    }]
  });
})();
class InlineNotificationSubtitle {
  constructor() {
    this.baseClass = true;
  }
  static {
    this.ɵfac = function InlineNotificationSubtitle_Factory(t) {
      return new (t || InlineNotificationSubtitle)();
    };
  }
  static {
    this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: InlineNotificationSubtitle,
      selectors: [["", "solInlineNotificationSubtitle", ""]],
      hostVars: 2,
      hostBindings: function InlineNotificationSubtitle_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵclassProp("sol-inline-notification-subtitle", ctx.baseClass);
        }
      }
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(InlineNotificationSubtitle, [{
    type: Directive,
    args: [{
      selector: '[solInlineNotificationSubtitle]'
    }]
  }], null, {
    baseClass: [{
      type: HostBinding,
      args: ['class.sol-inline-notification-subtitle']
    }]
  });
})();
class InlineNotification {
  static {
    this.notificationCount = 0;
  }
  /**
   * Set role attribute for component
   * `status` is default for inline-notification
   */
  get roleAttr() {
    return this._role;
  }
  get isSuccess() {
    return this.type === 'success';
  }
  get isInfo() {
    return this.type === 'info';
  }
  get isWarning() {
    return this.type === 'warning';
  }
  get isError() {
    return this.type === 'error';
  }
  get isCloseHidden() {
    return !this.showClose;
  }
  constructor(translationService) {
    this.translationService = translationService;
    this._role = 'status';
    this.closeLabel = this.translationService.getTranslation('closeNotification');
    this.title = '';
    this.message = '';
    this.type = 'info';
    this.showClose = true;
    this.show = true;
    /**
     * Emits on close.
     */
    this.close = new EventEmitter();
    this.notificationID = `notification-${InlineNotification.notificationCount++}`;
  }
  /**
   * Emits close event.
   */
  onClose() {
    this.show = false;
    this.close.emit();
  }
  static {
    this.ɵfac = function InlineNotification_Factory(t) {
      return new (t || InlineNotification)(i0.ɵɵdirectiveInject(i1.TranslationService));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: InlineNotification,
      selectors: [["sol-inline-notification"]],
      hostVars: 2,
      hostBindings: function InlineNotification_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵattribute("role", ctx.roleAttr)("id", ctx.notificationID);
        }
      },
      inputs: {
        title: "title",
        message: "message",
        type: "type",
        showClose: "showClose",
        show: "show"
      },
      outputs: {
        close: "close"
      },
      decls: 1,
      vars: 1,
      consts: [["class", "sol-inline-notification", 3, "sol-inline-notification-success", "sol-inline-notification-info", "sol-inline-notification-warning", "sol-inline-notification-error", 4, "ngIf"], [1, "sol-inline-notification"], [1, "sol-inline-notification-details"], ["class", "sol-inline-notification-icon", "width", "20", "height", "20", "viewBox", "0 0 20 20", "fill", "none", "xmlns", "http://www.w3.org/2000/svg", 4, "ngIf"], ["class", "sol-inline-notification-icon", "width", "20", "height", "19", "viewBox", "0 0 20 19", "fill", "none", "xmlns", "http://www.w3.org/2000/svg", 4, "ngIf"], [1, "sol-inline-notification-text-wrapper"], ["solInlineNotificationTitle", "", 3, "innerHTML"], ["solInlineNotificationSubtitle", "", 3, "innerHTML"], ["class", "sol-inline-notification-close-button", "type", "button", 3, "click", 4, "ngIf"], ["width", "20", "height", "20", "viewBox", "0 0 20 20", "fill", "none", "xmlns", "http://www.w3.org/2000/svg", 1, "sol-inline-notification-icon"], ["d", "M10 0C4.5 0 0 4.5 0 10C0 15.5 4.5 20 10 20C15.5 20 20 15.5 20 10C20 4.5 15.5 0 10 0ZM15.2 8.1L9.5 13.8C9.3 14 9 14.1 8.8 14.1C8.5 14.1 8.2 14 8 13.8L5.2 11C4.8 10.6 4.8 10 5.2 9.6C5.6 9.2 6.2 9.2 6.6 9.6L8.8 11.8L13.8 6.8C14.2 6.4 14.8 6.4 15.2 6.8C15.6 7.2 15.6 7.7 15.2 8.1Z", "fill", "none"], ["d", "M10 0C4.5 0 0 4.5 0 10C0 15.5 4.5 20 10 20C15.5 20 20 15.5 20 10C20 4.5 15.5 0 10 0ZM11 14.5C11 15 10.5 15.5 10 15.5C9.4 15.5 9 15 9 14.5V10.5C9 10 9.4 9.5 10 9.5C10.5 9.5 11 10 11 10.5V14.5ZM11 6.5C11 7 10.5 7.5 10 7.5C9.4 7.5 9 7 9 6.5V5.5C9 5 9.4 4.5 10 4.5C10.5 4.5 11 5 11 5.5V6.5Z", "fill", "none"], ["width", "20", "height", "19", "viewBox", "0 0 20 19", "fill", "none", "xmlns", "http://www.w3.org/2000/svg", 1, "sol-inline-notification-icon"], ["d", "M19.7956 16.0157L11.8074 1.09424C11.408 0.397906 10.7091 0 10.0101 0C9.31116 0 8.61219 0.397906 8.21279 1.09424L0.224666 16.0157C-0.0748887 16.6126 -0.0748887 17.4084 0.224666 18.0052C0.624072 18.6021 1.22318 19 1.92214 19H17.8984C18.5973 19 19.2963 18.6021 19.5959 18.0052C20.0951 17.3089 20.0951 16.6126 19.7956 16.0157ZM10.0101 15.9162C9.41101 15.9162 9.0116 15.5183 9.0116 14.9215C9.0116 14.3246 9.41101 13.9267 10.0101 13.9267C10.5094 13.9267 11.0086 14.3246 11.0086 14.9215C11.0086 15.5183 10.5094 15.9162 10.0101 15.9162ZM11.0086 10.9424C11.0086 11.5393 10.5094 11.9372 10.0101 11.9372C9.41101 11.9372 9.0116 11.5393 9.0116 10.9424V6.96335C9.0116 6.36649 9.41101 5.96859 10.0101 5.96859C10.5094 5.96859 11.0086 6.36649 11.0086 6.96335V10.9424Z", "fill", "none"], ["fill-rule", "evenodd", "clip-rule", "evenodd", "d", "M6.68629 0C6.15586 0 5.64715 0.210714 5.27208 0.585787L0.585787 5.27208C0.210714 5.64715 0 6.15586 0 6.68629V13.3137C0 13.8441 0.210714 14.3528 0.585787 14.7279L5.27208 19.4142C5.64715 19.7893 6.15586 20 6.68629 20H13.3137C13.8441 20 14.3528 19.7893 14.7279 19.4142L19.4142 14.7279C19.7893 14.3528 20 13.8441 20 13.3137V6.68629C20 6.15586 19.7893 5.64715 19.4142 5.27208L14.7279 0.585787C14.3528 0.210714 13.8441 0 13.3137 0H6.68629ZM9.0116 9.97382V5.99476C9.0116 5.39791 9.411 5 10.0101 5C10.5094 5 11.0086 5.39791 11.0086 5.99476V9.97382C11.0086 10.5707 10.5094 10.9686 10.0101 10.9686C9.411 10.9686 9.0116 10.5707 9.0116 9.97382ZM9.0116 13.9529C9.0116 13.356 9.411 12.9581 10.0101 12.9581C10.5094 12.9581 11.0086 13.356 11.0086 13.9529C11.0086 14.5497 10.5094 14.9476 10.0101 14.9476C9.411 14.9476 9.0116 14.5497 9.0116 13.9529Z", "fill", "none"], ["type", "button", 1, "sol-inline-notification-close-button", 3, "click"], ["width", "12", "height", "12", "viewBox", "0 0 12 12", "fill", "none", "xmlns", "http://www.w3.org/2000/svg", 1, "sol-inline-notification-close-icon"], ["d", "M7.3125 6.04651L11.7188 1.67442C12.0938 1.30233 12.0938 0.744186 11.7188 0.372093C11.3438 -6.93077e-08 10.7812 -6.93077e-08 10.4062 0.372093L6 4.74419L1.59375 0.27907C1.21875 -0.0930233 0.65625 -0.0930233 0.28125 0.27907C-0.09375 0.651163 -0.09375 1.2093 0.28125 1.5814L4.6875 6.04651L0.28125 10.4186C-0.09375 10.7907 -0.09375 11.3488 0.28125 11.7209C0.65625 12.093 1.21875 12.093 1.59375 11.7209L6 7.34884L10.4062 11.7209C10.7812 12.093 11.3438 12.093 11.7188 11.7209C12.0938 11.3488 12.0938 10.7907 11.7188 10.4186L7.3125 6.04651Z", "fill", "none"]],
      template: function InlineNotification_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, InlineNotification_div_0_Template, 10, 15, "div", 0);
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngIf", ctx.show);
        }
      },
      dependencies: [i2.NgIf, InlineNotificationTitle, InlineNotificationSubtitle, i1.TranslationPipe],
      styles: [".sol-inline-notification{position:relative;box-sizing:border-box;display:flex;justify-content:space-between;padding:1rem 2rem;margin-top:20px;border-width:1px 1px 1px 4px;border-style:solid}.sol-inline-notification .sol-inline-notification-details{display:flex;align-items:flex-start}.sol-inline-notification .sol-inline-notification-details .sol-inline-notification-icon{margin:0 1rem 0 0;min-height:1.25rem;min-width:1.25rem}.sol-inline-notification .sol-inline-notification-details .sol-inline-notification-text-wrapper{display:inline-flex;flex-wrap:wrap;align-items:center;min-height:1.25rem}.sol-inline-notification .sol-inline-notification-details .sol-inline-notification-text-wrapper .sol-inline-notification-title{margin:0 .5rem 0 0;padding:0;display:inline;text-transform:var(--typography-opensans-body-subtitle2-text-case);text-indent:var(--typography-opensans-body-subtitle2-paragraph-indent);line-height:var(--typography-opensans-body-subtitle2-line-height);letter-spacing:var(--typography-opensans-body-subtitle2-letter-spacing);font-stretch:var(--typography-opensans-body-subtitle2-font-stretch);font-style:var(--typography-opensans-body-subtitle2-font-style);font-weight:var(--typography-opensans-body-subtitle2-font-weight);font-family:var(--typography-opensans-body-subtitle2-font-family);text-decoration:var(--typography-opensans-body-subtitle2-text-decoration);font-size:var(--typography-opensans-body-subtitle2-font-size);word-break:break-word;-webkit-hyphens:auto;hyphens:auto}.sol-inline-notification .sol-inline-notification-details .sol-inline-notification-text-wrapper .sol-inline-notification-subtitle{display:inline;padding:0;margin:0;text-transform:var(--typography-opensans-body-body1-text-case);text-indent:var(--typography-opensans-body-body1-paragraph-indent);line-height:var(--typography-opensans-body-body1-line-height);letter-spacing:var(--typography-opensans-body-body1-letter-spacing);font-stretch:var(--typography-opensans-body-body1-font-stretch);font-style:var(--typography-opensans-body-body1-font-style);font-weight:var(--typography-opensans-body-body1-font-weight);font-family:var(--typography-opensans-body-body1-font-family);text-decoration:var(--typography-opensans-body-body1-text-decoration);font-size:var(--typography-opensans-body-body1-font-size);word-break:break-word;-webkit-hyphens:auto;hyphens:auto;white-space:pre-line}.sol-inline-notification .sol-inline-notification-close-button{margin:0 0 0 1rem;display:flex;min-width:1.25rem;height:1.25rem;flex-direction:column;align-items:center;justify-content:center;padding:0;border:none;background:transparent;cursor:pointer}.sol-inline-notification .sol-inline-notification-close-button:focus-visible{outline:1px solid var(--color-globalstate-focus)}.sol-inline-notification .sol-inline-notification-close-button .sol-inline-notification-close-icon path{fill:var(--color-interface-text800)}.sol-inline-notification.sol-inline-notification-success{border-color:var(--color-interface-success450);background:#e2faf1}.sol-inline-notification.sol-inline-notification-success .sol-inline-notification-icon path{fill:var(--color-interface-success450)}.sol-inline-notification.sol-inline-notification-info{border-color:var(--color-interface-info550);background:#f4f5ff}.sol-inline-notification.sol-inline-notification-info .sol-inline-notification-icon path{fill:var(--color-interface-info550)}.sol-inline-notification.sol-inline-notification-warning{border-color:var(--color-interface-warning300);background:#fff7da}.sol-inline-notification.sol-inline-notification-warning .sol-inline-notification-icon path{fill:var(--color-interface-warning300)}.sol-inline-notification.sol-inline-notification-error{border-color:var(--color-interface-error500);background:#fdf0f1}.sol-inline-notification.sol-inline-notification-error .sol-inline-notification-icon path{fill:var(--color-interface-error500)}\n"],
      encapsulation: 2,
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(InlineNotification, [{
    type: Component,
    args: [{
      selector: 'sol-inline-notification',
      encapsulation: ViewEncapsulation.None,
      changeDetection: ChangeDetectionStrategy.OnPush,
      template: "<div\n  *ngIf=\"show\"\n  class=\"sol-inline-notification\"\n  [class.sol-inline-notification-success]=\"isSuccess\"\n  [class.sol-inline-notification-info]=\"isInfo\"\n  [class.sol-inline-notification-warning]=\"isWarning\"\n  [class.sol-inline-notification-error]=\"isError\"\n>\n  <div class=\"sol-inline-notification-details\">\n    <!-- Success Icon -->\n    <svg\n      *ngIf=\"type == 'success'\"\n      class=\"sol-inline-notification-icon\"\n      width=\"20\"\n      height=\"20\"\n      viewBox=\"0 0 20 20\"\n      fill=\"none\"\n      xmlns=\"http://www.w3.org/2000/svg\"\n    >\n      <title>{{ 'successNotification' | translate }}</title>\n      <path\n        d=\"M10 0C4.5 0 0 4.5 0 10C0 15.5 4.5 20 10 20C15.5 20 20 15.5 20 10C20 4.5 15.5 0 10 0ZM15.2 8.1L9.5 13.8C9.3 14 9 14.1 8.8 14.1C8.5 14.1 8.2 14 8 13.8L5.2 11C4.8 10.6 4.8 10 5.2 9.6C5.6 9.2 6.2 9.2 6.6 9.6L8.8 11.8L13.8 6.8C14.2 6.4 14.8 6.4 15.2 6.8C15.6 7.2 15.6 7.7 15.2 8.1Z\"\n        fill=\"none\"\n      />\n    </svg>\n\n    <!-- Info Icon -->\n    <svg\n      *ngIf=\"type == 'info'\"\n      class=\"sol-inline-notification-icon\"\n      width=\"20\"\n      height=\"20\"\n      viewBox=\"0 0 20 20\"\n      fill=\"none\"\n      xmlns=\"http://www.w3.org/2000/svg\"\n    >\n      <title>{{ 'infoNotification' | translate }}</title>\n      <path\n        d=\"M10 0C4.5 0 0 4.5 0 10C0 15.5 4.5 20 10 20C15.5 20 20 15.5 20 10C20 4.5 15.5 0 10 0ZM11 14.5C11 15 10.5 15.5 10 15.5C9.4 15.5 9 15 9 14.5V10.5C9 10 9.4 9.5 10 9.5C10.5 9.5 11 10 11 10.5V14.5ZM11 6.5C11 7 10.5 7.5 10 7.5C9.4 7.5 9 7 9 6.5V5.5C9 5 9.4 4.5 10 4.5C10.5 4.5 11 5 11 5.5V6.5Z\"\n        fill=\"none\"\n      />\n    </svg>\n\n    <!-- Warning Icon -->\n    <svg\n      *ngIf=\"type == 'warning'\"\n      class=\"sol-inline-notification-icon\"\n      width=\"20\"\n      height=\"19\"\n      viewBox=\"0 0 20 19\"\n      fill=\"none\"\n      xmlns=\"http://www.w3.org/2000/svg\"\n    >\n      <title>{{ 'warningNotification' | translate }}</title>\n      <path\n        d=\"M19.7956 16.0157L11.8074 1.09424C11.408 0.397906 10.7091 0 10.0101 0C9.31116 0 8.61219 0.397906 8.21279 1.09424L0.224666 16.0157C-0.0748887 16.6126 -0.0748887 17.4084 0.224666 18.0052C0.624072 18.6021 1.22318 19 1.92214 19H17.8984C18.5973 19 19.2963 18.6021 19.5959 18.0052C20.0951 17.3089 20.0951 16.6126 19.7956 16.0157ZM10.0101 15.9162C9.41101 15.9162 9.0116 15.5183 9.0116 14.9215C9.0116 14.3246 9.41101 13.9267 10.0101 13.9267C10.5094 13.9267 11.0086 14.3246 11.0086 14.9215C11.0086 15.5183 10.5094 15.9162 10.0101 15.9162ZM11.0086 10.9424C11.0086 11.5393 10.5094 11.9372 10.0101 11.9372C9.41101 11.9372 9.0116 11.5393 9.0116 10.9424V6.96335C9.0116 6.36649 9.41101 5.96859 10.0101 5.96859C10.5094 5.96859 11.0086 6.36649 11.0086 6.96335V10.9424Z\"\n        fill=\"none\"\n      />\n    </svg>\n\n    <!-- Error Icon -->\n    <svg\n      *ngIf=\"type == 'error'\"\n      class=\"sol-inline-notification-icon\"\n      width=\"20\"\n      height=\"20\"\n      viewBox=\"0 0 20 20\"\n      fill=\"none\"\n      xmlns=\"http://www.w3.org/2000/svg\"\n    >\n      <title>{{ 'errorNotification' | translate }}</title>\n      <path\n        fill-rule=\"evenodd\"\n        clip-rule=\"evenodd\"\n        d=\"M6.68629 0C6.15586 0 5.64715 0.210714 5.27208 0.585787L0.585787 5.27208C0.210714 5.64715 0 6.15586 0 6.68629V13.3137C0 13.8441 0.210714 14.3528 0.585787 14.7279L5.27208 19.4142C5.64715 19.7893 6.15586 20 6.68629 20H13.3137C13.8441 20 14.3528 19.7893 14.7279 19.4142L19.4142 14.7279C19.7893 14.3528 20 13.8441 20 13.3137V6.68629C20 6.15586 19.7893 5.64715 19.4142 5.27208L14.7279 0.585787C14.3528 0.210714 13.8441 0 13.3137 0H6.68629ZM9.0116 9.97382V5.99476C9.0116 5.39791 9.411 5 10.0101 5C10.5094 5 11.0086 5.39791 11.0086 5.99476V9.97382C11.0086 10.5707 10.5094 10.9686 10.0101 10.9686C9.411 10.9686 9.0116 10.5707 9.0116 9.97382ZM9.0116 13.9529C9.0116 13.356 9.411 12.9581 10.0101 12.9581C10.5094 12.9581 11.0086 13.356 11.0086 13.9529C11.0086 14.5497 10.5094 14.9476 10.0101 14.9476C9.411 14.9476 9.0116 14.5497 9.0116 13.9529Z\"\n        fill=\"none\"\n      />\n    </svg>\n\n    <div class=\"sol-inline-notification-text-wrapper\">\n      @if (title) {\n        <div solInlineNotificationTitle [innerHTML]=\"title\"></div>\n      }\n      @if (message) {\n        <div solInlineNotificationSubtitle [innerHTML]=\"message\"></div>\n      }\n    </div>\n  </div>\n  <button *ngIf=\"!isCloseHidden\" (click)=\"onClose()\" class=\"sol-inline-notification-close-button\" [attr.aria-label]=\"closeLabel\" type=\"button\">\n    <svg class=\"sol-inline-notification-close-icon\" width=\"12\" height=\"12\" viewBox=\"0 0 12 12\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path\n        d=\"M7.3125 6.04651L11.7188 1.67442C12.0938 1.30233 12.0938 0.744186 11.7188 0.372093C11.3438 -6.93077e-08 10.7812 -6.93077e-08 10.4062 0.372093L6 4.74419L1.59375 0.27907C1.21875 -0.0930233 0.65625 -0.0930233 0.28125 0.27907C-0.09375 0.651163 -0.09375 1.2093 0.28125 1.5814L4.6875 6.04651L0.28125 10.4186C-0.09375 10.7907 -0.09375 11.3488 0.28125 11.7209C0.65625 12.093 1.21875 12.093 1.59375 11.7209L6 7.34884L10.4062 11.7209C10.7812 12.093 11.3438 12.093 11.7188 11.7209C12.0938 11.3488 12.0938 10.7907 11.7188 10.4186L7.3125 6.04651Z\"\n        fill=\"none\"\n      />\n    </svg>\n  </button>\n</div>\n",
      styles: [".sol-inline-notification{position:relative;box-sizing:border-box;display:flex;justify-content:space-between;padding:1rem 2rem;margin-top:20px;border-width:1px 1px 1px 4px;border-style:solid}.sol-inline-notification .sol-inline-notification-details{display:flex;align-items:flex-start}.sol-inline-notification .sol-inline-notification-details .sol-inline-notification-icon{margin:0 1rem 0 0;min-height:1.25rem;min-width:1.25rem}.sol-inline-notification .sol-inline-notification-details .sol-inline-notification-text-wrapper{display:inline-flex;flex-wrap:wrap;align-items:center;min-height:1.25rem}.sol-inline-notification .sol-inline-notification-details .sol-inline-notification-text-wrapper .sol-inline-notification-title{margin:0 .5rem 0 0;padding:0;display:inline;text-transform:var(--typography-opensans-body-subtitle2-text-case);text-indent:var(--typography-opensans-body-subtitle2-paragraph-indent);line-height:var(--typography-opensans-body-subtitle2-line-height);letter-spacing:var(--typography-opensans-body-subtitle2-letter-spacing);font-stretch:var(--typography-opensans-body-subtitle2-font-stretch);font-style:var(--typography-opensans-body-subtitle2-font-style);font-weight:var(--typography-opensans-body-subtitle2-font-weight);font-family:var(--typography-opensans-body-subtitle2-font-family);text-decoration:var(--typography-opensans-body-subtitle2-text-decoration);font-size:var(--typography-opensans-body-subtitle2-font-size);word-break:break-word;-webkit-hyphens:auto;hyphens:auto}.sol-inline-notification .sol-inline-notification-details .sol-inline-notification-text-wrapper .sol-inline-notification-subtitle{display:inline;padding:0;margin:0;text-transform:var(--typography-opensans-body-body1-text-case);text-indent:var(--typography-opensans-body-body1-paragraph-indent);line-height:var(--typography-opensans-body-body1-line-height);letter-spacing:var(--typography-opensans-body-body1-letter-spacing);font-stretch:var(--typography-opensans-body-body1-font-stretch);font-style:var(--typography-opensans-body-body1-font-style);font-weight:var(--typography-opensans-body-body1-font-weight);font-family:var(--typography-opensans-body-body1-font-family);text-decoration:var(--typography-opensans-body-body1-text-decoration);font-size:var(--typography-opensans-body-body1-font-size);word-break:break-word;-webkit-hyphens:auto;hyphens:auto;white-space:pre-line}.sol-inline-notification .sol-inline-notification-close-button{margin:0 0 0 1rem;display:flex;min-width:1.25rem;height:1.25rem;flex-direction:column;align-items:center;justify-content:center;padding:0;border:none;background:transparent;cursor:pointer}.sol-inline-notification .sol-inline-notification-close-button:focus-visible{outline:1px solid var(--color-globalstate-focus)}.sol-inline-notification .sol-inline-notification-close-button .sol-inline-notification-close-icon path{fill:var(--color-interface-text800)}.sol-inline-notification.sol-inline-notification-success{border-color:var(--color-interface-success450);background:#e2faf1}.sol-inline-notification.sol-inline-notification-success .sol-inline-notification-icon path{fill:var(--color-interface-success450)}.sol-inline-notification.sol-inline-notification-info{border-color:var(--color-interface-info550);background:#f4f5ff}.sol-inline-notification.sol-inline-notification-info .sol-inline-notification-icon path{fill:var(--color-interface-info550)}.sol-inline-notification.sol-inline-notification-warning{border-color:var(--color-interface-warning300);background:#fff7da}.sol-inline-notification.sol-inline-notification-warning .sol-inline-notification-icon path{fill:var(--color-interface-warning300)}.sol-inline-notification.sol-inline-notification-error{border-color:var(--color-interface-error500);background:#fdf0f1}.sol-inline-notification.sol-inline-notification-error .sol-inline-notification-icon path{fill:var(--color-interface-error500)}\n"]
    }]
  }], () => [{
    type: i1.TranslationService
  }], {
    roleAttr: [{
      type: HostBinding,
      args: ['attr.role']
    }],
    title: [{
      type: Input
    }],
    message: [{
      type: Input
    }],
    type: [{
      type: Input
    }],
    showClose: [{
      type: Input
    }],
    show: [{
      type: Input
    }],
    close: [{
      type: Output
    }],
    notificationID: [{
      type: HostBinding,
      args: ['attr.id']
    }]
  });
})();
class InlineNotificationModule {
  static {
    this.ɵfac = function InlineNotificationModule_Factory(t) {
      return new (t || InlineNotificationModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: InlineNotificationModule
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [CommonModule, TranslationModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(InlineNotificationModule, [{
    type: NgModule,
    args: [{
      declarations: [InlineNotification, InlineNotificationTitle, InlineNotificationSubtitle],
      exports: [InlineNotification, InlineNotificationTitle, InlineNotificationSubtitle],
      imports: [CommonModule, TranslationModule]
    }]
  }], null, null);
})();

/*
 * Public API Surface of toggle-group
 */

/**
 * Generated bundle index. Do not edit.
 */

export { InlineNotification, InlineNotificationModule, InlineNotificationSubtitle, InlineNotificationTitle };
